import React from 'react';

export default function (props) {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M9.29,16.29 C9.68,16.68 10.32,16.68 10.7,16.29 L18.29,8.7 C18.68,8.31 18.68,7.68 18.29,7.29 C17.9,6.9 17.27,6.9 16.88,7.29 L10,14.17 L7.11,11.29 C6.72,10.9 6.09,10.9 5.7,11.29 C5.31,11.68 5.31,12.31 5.7,12.7 L9.29,16.29 Z" fill={props.fill}/>
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/Components/assets/Tick.js